import { Routes } from '@angular/router';

import { authGuard } from './core/route-guards/auth.guard';
import { loginGuard } from './core/route-guards/login.guard';

export const APP_ROUTES: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    loadChildren: () => import('./home/home-routes').then((m) => m.HOME_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.component').then((m) => m.LoginComponent),
    canActivate: [loginGuard],
  },
  {
    path: 'callback',
    loadChildren: () => import('./callback/callback-routes').then((m) => m.CALLBACK_ROUTE),
  },
  {
    path: 'not-found',
    loadComponent: () => import('./not-found/not-found.component').then((m) => m.NotFoundComponent)
  },
  { path: '**', redirectTo: 'not-found' },
];

